import { useEffect, useState } from "react";
import {
  createGame,
  getGame,
  updateGame,
  getTeams,
  getTeamAthletes,
} from "../../services/api";
import { useParams, useNavigate } from "react-router-dom";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import PlayersSelector from "../../components/Scout/PlayersSelector";

export default function GameForm() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    date: "",
    time: "",
    league: "",
    season: "",
    bestoff: 5,
    pontosset: [25, 15],
    teams: { home: {}, away: {} },
    homeOrder: [],
    awayOrder: [],
    setterPos: [1, 2],
    serv: "*",
    video: "",
    tipoScout: "",
    publico: false,
  });
  const [formUpdate, setFormUpdate] = useState({
    date: "",
    time: "",
    league: "",
    season: "",
    bestoff: 5,
    pontosset: [25, 15],
    teams: { home: {}, away: {} },
    video: "",
    tipoScout: "",
    publico: false,
  });
  const [teams, setTeams] = useState([]);
  const [homeAthletes, setHomeAthletes] = useState([]);
  const [awayAthletes, setAwayAthletes] = useState([]);

  // const [tipoScout, setTipoScout] = useState("video");

  const loadTeams = async () => {
    const res = await getTeams();
    setTeams(res.data);
  };

  const loadAthletes = async (teamId, isHome) => {
    const res = await getTeamAthletes(teamId);
    const athletes = res.data.athletes.map((item) => ({
      number: item.number, // ou item.athlete.number dependendo da estrutura real
      name: item.athlete.name,
      function: item.function || item.athlete.function,
      surname: item.athlete.surname,
    }));

    if (isHome) setHomeAthletes(athletes);
    else setAwayAthletes(athletes);
  };

  useEffect(() => {
    loadTeams();
    if (id) {
      getGame(id).then(({ data }) => {
        setForm({
          ...data,
          serv: data.scout[0].set.serv,
          homeOrder: data.scout[0]["*"],
          awayOrder: data.scout[0].a,
          setterPos: [data.scout[0].sett[0], data.scout[0].sett[1]],
          tipoScout: data.tipoScout,
          video: data.video,
        });
        setFormUpdate({
          date: data.date,
          time: data.time,
          league: data.league,
          season: data.season,
          bestoff: data.bestoff,
          pontosset: data.pontosset,
          teams: {
            home: {
              _id: data?.teams?.home?._id,
              name: data?.teams?.home?.name,
              sets: data?.teams?.home?.sets ?? 0,
            },
            away: {
              _id: data?.teams?.away?._id,
              name: data?.teams?.away?.name,
              sets: data?.teams?.away?.sets ?? 0,
            },
          },
          video: data.video,
          tipoScout: data.tipoScout,
          publico: data.publico,
        });
        if (data?.teams?.home?._id) {
          loadAthletes(data?.teams?.home?._id, true);
          //   loadAthletes("683b2fd0374ef5730a0a17f5", true);
        }
        if (data?.teams?.away?._id) {
          loadAthletes(data?.teams?.away?._id, false);
          //   loadAthletes("683b3138374ef5730a0a1805", false);
        }
      });
    }
  }, [id]);

  const handleSubmit = async () => {
    const homePlayers = homeAthletes.map((athlete) => ({
      number: athlete.number,
      function: athlete.function || "",
      name: athlete.name || "",
      surname: athlete.surname || "",
    }));

    const awayPlayers = awayAthletes.map((athlete) => ({
      number: athlete.number,
      function: athlete.function || "",
      name: athlete.name || "",
      surname: athlete.surname || "",
    }));

    const gameData = {
      ...form,
      //! esse bloco de teams nao precisa ser gravado.
      teams: {
        home: {
          _id: form.teams?.home?._id,
          name: form.teams?.home?.name,
          sets: form.teams?.home?.sets ?? 0,
        },
        away: {
          _id: form.teams?.away?._id,
          name: form.teams?.away?.name,
          sets: form.teams?.away?.sets ?? 0,
        },
      },
      players: {
        home: homePlayers,
        away: awayPlayers,
      },
      homeOrder: form.homeOrder,
      awayOrder: form.awayOrder,
      setterPos: form.setterPos,
      pontosset: form.pontosset,
      serv: form.serv,
      tipoScout: form.tipoScout,
      publico: form.publico,
      video: form.video,
    };

    const gameDataAlteracao = {
      ...formUpdate,
      teams: {
        home: {
          name: formUpdate.teams?.home?.name,
        },
        away: {
          name: formUpdate.teams?.away?.name,
        },
      },
      pontosset: formUpdate.pontosset,
      tipoScout: formUpdate.tipoScout,
      publico: formUpdate.publico,
      video: formUpdate.video,
    };

    if (id) {
      await updateGame(id, gameDataAlteracao);
    } else {
      await createGame(gameData);
    }

    navigate("/admin/games");
  };

  return (
    <div className="p-6 max-w-3xl mt-20 space-y-4">
      <h1 className="text-xl font-bold">{id ? "Editar" : "Nova"} Partida</h1>
      <div className="grid grid-cols-2 gap-4">
        <Input
          placeholder="Data"
          value={form.date}
          onChange={(e) => {
            setForm({ ...form, date: e.target.value });
            setFormUpdate({ ...formUpdate, date: e.target.value });
          }}
        />
        <Input
          placeholder="Hora"
          value={form.time}
          onChange={(e) => {
            setForm({ ...form, time: e.target.value });
            setFormUpdate({ ...formUpdate, time: e.target.value });
          }}
        />
        <Input
          placeholder="Liga"
          value={form.league}
          onChange={(e) => {
            setForm({ ...form, league: e.target.value });
            setFormUpdate({ ...formUpdate, league: e.target.value });
          }}
        />
        <Input
          placeholder="Temporada"
          value={form.season}
          onChange={(e) => {
            setForm({ ...form, season: e.target.value });
            setFormUpdate({ ...formUpdate, season: e.target.value });
          }}
        />
        <div>
          Melhor de:
          <Input
            type="number"
            placeholder="Best Of"
            value={form.bestoff}
            onChange={(e) => {
              setForm({ ...form, bestoff: +e.target.value });
              setFormUpdate({ ...formUpdate, bestoff: +e.target.value });
            }}
          />
        </div>
        <div className="flex gap-2">
          [regulares, tie-break]
          {[0, 1].map((i) => (
            <Input
              key={i}
              type="number"
              placeholder={`Pontos Set ${i + 1}`}
              value={form.pontosset[i]}
              onChange={(e) => {
                const pts = [...form.pontosset];
                pts[i] = +e.target.value;
                setForm({ ...form, pontosset: pts });
                const ptsUpdate = [...formUpdate.pontosset];
                ptsUpdate[i] = +e.target.value;
                setFormUpdate({ ...formUpdate, pontosset: ptsUpdate });
              }}
            />
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <input
          list="teams-home"
          value={form.teams?.home?.name || ""}
          onChange={(e) => {
            const team = teams.find((t) => t.name === e.target.value);
            setForm({
              ...form,
              teams: {
                ...form.teams,
                home: {
                  _id: team ? team._id : undefined,
                  name: e.target.value,
                  sets: form.teams.home?.sets || 0,
                },
              },
            });
            setFormUpdate({
              ...formUpdate,
              teams: {
                ...formUpdate.teams,
                home: {
                  name: e.target.value,
                },
              },
            });
            if (team) loadAthletes(team._id, true);
          }}
          placeholder="Time Casa"
        />
        <datalist id="teams-home">
          {teams.map((t) => (
            <option key={t._id} value={t.name} />
          ))}
        </datalist>
        <input
          list="teams-away"
          value={form.teams?.away?.name || ""}
          onChange={(e) => {
            const team = teams.find((t) => t.name === e.target.value);
            setForm({
              ...form,
              teams: {
                ...form.teams,
                away: {
                  _id: team ? team._id : undefined,
                  name: e.target.value,
                  sets: form.teams.away?.sets || 0,
                },
              },
            });
            setFormUpdate({
              ...formUpdate,
              teams: {
                ...formUpdate.teams,
                away: {
                  name: e.target.value,
                },
              },
            });
            if (team) loadAthletes(team._id, false);
          }}
          placeholder="Time Visitante"
        />
        <datalist id="teams-away">
          {teams.map((t) => (
            <option key={t._id} value={t.name} />
          ))}
        </datalist>
      </div>
      <div>
        <label>Saque inicial:</label>
        <select
          value={form.serv}
          onChange={(e) => setForm({ ...form, serv: e.target.value })}
        >
          <option value="*">Time Casa</option>
          <option value="a">Time Visitante</option>
        </select>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <PlayersSelector
          label="Escalação Time Casa"
          athletes={homeAthletes}
          selected={form.homeOrder}
          onChange={(order) => setForm({ ...form, homeOrder: order })}
          isHome={true}
        />
        <PlayersSelector
          label="Escalação Time Visitante"
          athletes={awayAthletes}
          selected={form.awayOrder}
          onChange={(order) => setForm({ ...form, awayOrder: order })}
          isHome={false}
        />
      </div>
      PLACAR
      <Input
        type="number"
        placeholder="Sets Home"
        value={form.teams?.home?.sets ?? 0}
        onChange={(e) =>
          setForm({
            ...form,
            teams: {
              ...form.teams,
              home: { ...form.teams?.home, sets: +e.target.value },
            },
          })
        }
      />
      <Input
        type="number"
        placeholder="Sets Away"
        value={form.teams?.away?.sets ?? 0}
        onChange={(e) =>
          setForm({
            ...form,
            teams: {
              ...form.teams,
              away: { ...form.teams?.away, sets: +e.target.value },
            },
          })
        }
      />
      <div>
        <label>Posição dos Levantadores [home, away]</label>
        <Input
          value={form.setterPos.join(",")}
          onChange={(e) => {
            const parts = e.target.value.split(",").map((n) => parseInt(n));
            setForm({ ...form, setterPos: parts });
          }}
        />
      </div>
      <div>
        <label>Tipo de Scout</label>
        <select
          value={form.tipoScout}
          onChange={(e) => {
            setForm({ ...form, tipoScout: e.target.value });
            setFormUpdate({ ...formUpdate, tipoScout: e.target.value });
          }}
        >
          <option value="video">Vídeo</option>
          <option value="live">Live</option>
          <option value="">Só Scout</option>
        </select>
      </div>
      <div>
        <label>URL do vídeo</label>
        <Input
          value={form.video ?? null}
          onChange={(e) => {
            setForm({ ...form, video: e.target.value });
            setFormUpdate({ ...formUpdate, video: e.target.value });
          }}
          required={form.tipoScout === "video"}
        />
      </div>
      <div>
        <label>Público</label>
        <select
          value={form.publico}
          onChange={(e) => {
            setForm({ ...form, publico: e.target.value });
            setFormUpdate({ ...formUpdate, publico: e.target.value });
          }}
        >
          <option value="true">Sim</option>
          <option value="false">Não</option>
        </select>
      </div>
      <Button className="mt-4" onClick={handleSubmit}>
        {id ? "Salvar" : "Criar"}
      </Button>
      <Button
        className="mt-4 ml-4"
        onClick={() => {
          navigate("/admin/games");
        }}
      >
        Cancelar
      </Button>
    </div>
  );
}
